import { html, TemplateResult } from 'lit';
import { ColumnDetails } from '../../../grid/types/common';
import { Column, ColumnKeys, getTranslatedQuarantineModuleToName } from '../types';
import { translateFn } from '../../../utils/translator.helper';

export function renderDetectingTechnology(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>): TemplateResult {
  const module = rowData?.item[columnDetails.key];
  const quarantineModuleToName = getTranslatedQuarantineModuleToName();

  if (!module || !quarantineModuleToName[module]) {
    return translateFn('N/A');
  }

  return html`<gz-grid-cell-default-renderer
        .label="${quarantineModuleToName[module]}"
      ></gz-grid-cell-default-renderer>`;
}
